import { render, staticRenderFns } from "./CoBenefitsWidget.vue?vue&type=template&id=1cc35b96&"
import script from "./CoBenefitsWidget.vue?vue&type=script&lang=js&"
export * from "./CoBenefitsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports